import { DEFAULT_NUMBER, formatFraction, formatInvalidHOC, formatSignificant, SORTED_UNITS, } from './numberHelper';
const MAX_DIGITS_FRACTION = 2;
const MAX_DIGITS_SIGNIFICANT = 4;
/**
 * 1000 => 1,000
 */
const formatInt = (value, locales) => formatInvalidHOC(formatFraction)(value, 0, 0, locales);
/**
 * 1000 => 1,000, 1000.005 => 1,000.01
 */
const formatDecimal = formatInvalidHOC((value, minDigits = 0, maxDigits = MAX_DIGITS_FRACTION, locales) => formatFraction(value, minDigits, maxDigits, locales));
/**
 * 0 => 0, 0.12345 => 0.1235
 */
const formatPureDecimal = (value, effective = MAX_DIGITS_SIGNIFICANT, locales) => 
// ignore min param which is meaningless
formatInvalidHOC(formatSignificant)(value, undefined, effective, locales);
const formatUnit = (value, { minUnit, units = SORTED_UNITS, format = (value, unit) => `${value}${unit}`, } = {}, { min = MAX_DIGITS_FRACTION, max = min } = {}) => {
    for (const { unit, base } of units) {
        if (value >= base) {
            const text = formatDecimal(typeof value === 'bigint' ? BigInt(value) / BigInt(base) : value / base, min, max);
            if (text === DEFAULT_NUMBER)
                return;
            return format(text, unit);
        }
        if (unit === minUnit)
            break;
    }
    return;
};
/**
 * smaller than 1 formatPureDecimal, otherwise formatDecimal
 * @param value
 * @param DigitsOpts
 * @returns 2222.005 => 2,222.01, 0.12345 => 0.1235
 */
const formatPrice = (value, { min = MAX_DIGITS_FRACTION, max, effective } = {}) => typeof value === 'bigint' || Math.abs(value) >= 1
    ? formatDecimal(value, min, max)
    : formatPureDecimal(value, effective);
/**
 * formatUnit if can, otherwise formatPrice
 * @param value
 * @param opts
 * @param digitsOpts
 * @returns
 */
const formatAbbreviation = (value, opts, digitsOpts) => formatUnit(value, opts, digitsOpts) ?? formatPrice(value, digitsOpts);
/**
 * formatUnit if can, otherwise formatInt
 * @param value
 * @param opts
 * @returns
 */
const formatIntAbbreviation = (value, opts) => formatUnit(value, opts, { min: 0, max: MAX_DIGITS_FRACTION }) ??
    formatInt(value);
/**
 * formatUnit if can, otherwise formatDecimal
 * @param value
 * @param opts
 * @returns 1005 => 1.01K, 22.1234 => 22.12
 */
const formatVolume = (value, opts, digitsOpts) => formatUnit(value, opts, digitsOpts) ??
    formatDecimal(value, digitsOpts?.min !== undefined ? digitsOpts.min : MAX_DIGITS_FRACTION);
/**
 * formatDecimal and combine %
 * @param value
 * @param withoutSign
 * @returns
 */
const formatPercentage = (value, withoutSign = false, format = (sign, value, symbol) => sign + value + symbol, abbr = false, minDigits = MAX_DIGITS_FRACTION, maxDigits) => {
    const res = abbr
        ? formatVolume(typeof value === 'number' ? value * 100 : value * BigInt(100))
        : formatDecimal(typeof value === 'number' ? value * 100 : value * BigInt(100), minDigits, maxDigits);
    // if (res === DEFAULT_NUMBER) return res;
    return format(!withoutSign && value >= 0 ? '+' : '', res, '%');
};
const formatApr = (value) => formatPercentage(value, true, (s, v, sy) => `${v} ${sy}`, true);
export { formatAbbreviation, formatApr, formatDecimal, formatInt, formatIntAbbreviation, formatPercentage, formatPrice, formatPureDecimal, formatVolume, };
